<template>
    <b-modal
        v-model="user_modal"
        :title="form_new ? $t('organization.new_user') : $t('organization.edit_user')"
        autocomplete="off"
        modal-class="apprentice-default-modal"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')">
        <b-form @submit.prevent="submitUser">
            <b-alert
                variant="info"
                show>
                {{
                    $t(
                        'organization.username_and_password_may_be_empty_in_this_case_a_username_and_or_password_will_be_generated_automatically',
                    )
                }}
            </b-alert>

            <div class="row">
                <div class="col-md-12">
                    <b-form-group
                        :label="$t('common.first_name')"
                        label-for="name">
                        <b-form-input
                            id="name"
                            v-model="form.name"
                            required
                            :placeholder="$t('common.first_name')"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <b-form-group
                        :label="$t('common.infix')"
                        label-for="preposition">
                        <b-form-input
                            id="preposition"
                            v-model="form.preposition"
                            :placeholder="$t('common.infix')"></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-8">
                    <b-form-group
                        :label="$t('common.last_name')"
                        label-for="surname">
                        <b-form-input
                            id="surname"
                            v-model="form.surname"
                            required
                            :placeholder="$t('common.last_name')"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <b-form-group
                        label="E-mail:"
                        label-for="email">
                        <b-form-input
                            id="email"
                            v-model="form.email"
                            type="email"
                            required
                            placeholder="E-mail"></b-form-input>
                    </b-form-group>

                    <div v-show="email_check">
                        <b-alert
                            show
                            variant="danger"
                            >{{ $t('organization.email_address_already_in_use') }}</b-alert
                        >
                    </div>
                </div>
            </div>

            <b-form-group
                :label="$t('common.username')"
                label-for="username">
                <b-form-input
                    id="username"
                    v-model="form.username"
                    :placeholder="$t('common.username')"></b-form-input>
            </b-form-group>

            <div v-show="username_check">
                <b-alert
                    show
                    variant="danger"
                    >{{ $t('organization.username_already_in_use') }}</b-alert
                >
            </div>

            <b-form-group
                :label="$t('common.password')"
                label-for="password">
                <b-form-input
                    id="password"
                    v-model="form.password"
                    type="password"
                    autocomplete="new-password"
                    :placeholder="$t('common.password')"></b-form-input>
            </b-form-group>

            <b-form-group
                :label="$t('organization.confirm_password')"
                label-for="checkPassword">
                <b-form-input
                    id="password"
                    v-model="checkPassword"
                    type="password"
                    autocomplete="new-password"
                    :placeholder="$t('common.password')"></b-form-input>
            </b-form-group>

            <div v-show="notSamePasswords">
                <b-alert
                    show
                    variant="danger">
                    {{ $t('organization.passwords_do_not_match') }}</b-alert
                >
            </div>

            <b-button
                v-if="form_new"
                @click="resetForm"
                type="reset"
                variant="outline-primary">
                {{ $t('common.reset') }}}
            </b-button>
            <b-button
                type="submit"
                variant="primary">
                {{ $t('common.save') }}
            </b-button>
        </b-form>

        <template #modal-footer="{ ok, cancel, hide }">
            <div class="footer-controls">
                <b-button
                    v-if="form_new"
                    @click="cancel()"
                    type="reset"
                    variant="outline-primary">
                    {{ $t('common.cancel') }}
                </b-button>
                <b-button
                    v-if="form_new"
                    @click="resetForm"
                    type="reset"
                    variant="outline-primary">
                    Reset
                </b-button>

                <b-button
                    type="submit"
                    variant="primary"
                    @click="submitUser">
                    {{ $t('common.save') }}
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-organization-settings-user-add-modal-component',
    props: ['organizationIn', 'usersIn'],
    data() {
        return {
            user_modal: false,
            form_new: true,
            email_check: false,
            username_check: false,
            checkPassword: '',
            form: {
                id: '',
                name: '',
                preposition: '',
                surname: '',
                email: '',
                username: '',
                password: '',
            },
        };
    },
    computed: {
        notSamePasswords() {
            if (this.passwordsFilled) {
                return this.form.password !== this.checkPassword;
            } else {
                return false;
            }
        },
        passwordsFilled() {
            return this.form.password !== '' && this.checkPassword !== '';
        },
    },
    methods: {
        show() {
            this.user_modal = true;
        },
        submitUser() {
            this.username_check = false;
            this.email_check = false;

            for (const user of this.usersIn) {
                if (this.form.username === '') {
                    this.username_check = false;
                } else if (this.form.username === user.username) {
                    this.username_check = true;
                }

                if (this.form.email === '') {
                    this.email_check = false;
                } else if (this.form.email === user.email) {
                    this.email_check = true;
                }
            }

            if (this.email_check || this.username_check || this.notSamePasswords) {
                return;
            }

            this.alert.saving();

            this.axios.post(this.routes.organizationUserAdd(this.organizationIn.id), this.form).then(
                (response) => {
                    this.user_modal = false;
                    this.username_check = false;
                    this.email_check = false;
                    this.checkPassword = '';

                    this.$emit('user-added', response.data);

                    this.alert.success();

                    this.resetForm();
                },
                (error) => {
                    if (error.response.data.errors.email) {
                        this.alert.close();
                        this.email_check = true;
                    }

                    if (error.response.data.errors.username) {
                        this.alert.close();
                        this.username_check = true;
                    }

                    if (!this.email_check && !this.username_check) {
                        this.alert.ajaxError(error);
                    }
                },
            );
        },

        resetForm() {
            this.form.id = '';
            this.form.name = '';
            this.form.email = '';
            this.form.preposition = '';
            this.form.surname = '';
            this.form.username = '';
            this.form.password = '';
            this.form.role = '';
            this.form_new = true;
            this.email_check = false;
            this.username_check = false;
            this.checkPassword = '';
        },
    },
};
</script>

<style scoped></style>
